import { runAfterBootstrap } from 'owa-delayed-initialization';

import initCalendarMailboxConfiguration from './actions/initCalendarMailboxConfiguration';
import initTxpSettings from './actions/initTxpSettings';
import './mutators/updateTxpSettingFlagMutator';

// Load initial state needed for options
runAfterBootstrap(() => {
    initCalendarMailboxConfiguration();
    initTxpSettings();
});

export {
    default as saveCalendarMailboxConfiguration,
} from './actions/saveCalendarMailboxConfiguration';

export { default as getCalendarConfiguration } from './utils/getCalendarConfiguration';
export {
    default as getCalendarConfigWorkingHoursTimeZoneId,
} from './utils/getCalendarConfigWorkingHoursTimeZoneId';

export {
    default as initCalendarMailboxConfiguration,
} from './actions/initCalendarMailboxConfiguration';

export { default as initTxpSettings } from './actions/initTxpSettings';

export { default as reloadTxpSettings } from './actions/reloadTxpSettings';

export {
    default as updateCalendarMailboxConfiguration,
} from './actions/updateCalendarMailboxConfiguration';

export {
    default as setMailboxCalendarConfiguration,
} from './services/setMailboxCalendarConfiguration';

export { default as TxpGriffinSettingsPayload } from './store/schema/TxpGriffinSettingsPayload';
export { TxpDisableReason } from './store/schema/TxpDisableReason';

export { updateTxpSettingFlag } from './actions/updateTxpSettingFlag';
